"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugLog = void 0;
function debugLog() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (process.env.DEBUG !== "sentence-splitter") {
        return;
    }
    console.log.apply(console, __spreadArray(["sentence-splitter: "], args));
}
exports.debugLog = debugLog;
//# sourceMappingURL=logger.js.map